import BusinessIcon from '@material-ui/icons/Business';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import MenuBookOutlinedIcon from '@material-ui/icons/MenuBookOutlined';
import TimelineIcon from '@material-ui/icons/Timeline';
import WidgetsIcon from '@material-ui/icons/Widgets';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PasswordIcon from '@mui/icons-material/Password';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import RequestQuoteSharpIcon from '@mui/icons-material/RequestQuoteSharp';
import { ListItemLink } from '../../../components/sidebar-list-item-link';

import { Route, Switch } from 'react-router-dom';
import DashboardContainer from './dashboard/dashboard';
import ParcelContainer from './parcel';
import BookParcel from './parcel/create';
import ViewParcel from './parcel/_id';
import EditParcel from './parcel/edit';
import Rider from './rider';
import RiderDashboard from './rider_dashboard';
import CreateRider from './rider/createRider';
import EditRider from './rider/editRider';
import Company from './company';
import CreateCompany from './company/createCompany';
import EditCompany from './company/editCompany';
import BalanceContainer from './balance/index';
import PaymentCreate from './payments/create';
import Payment from './payments/index';
import PaymentShow from './payments/invoice';
import Deposit from './deposit/index';
import Area from './area';
import CreateArea from './area/createArea';
import EditArea from './area/editArea';
import ChangePassword from './change_password';
import DeliveryCharge from './delivery_charge';

const routeList = [
  { to: '/dashboard', primary: 'Dashboard', icon: TimelineIcon, component: DashboardContainer },
  { to: '/dashboard/parcel', primary: 'Parcels', icon: WidgetsIcon, component: ParcelContainer },
  { to: '/dashboard/parcel/create', primary: 'Parcels', component: BookParcel },
  { to: '/dashboard/parcel/edit/:id', primary: 'Parcels', component: EditParcel },
  { to: '/dashboard/parcel/:id', primary: 'Parcels', component: ViewParcel },
  { to: '/dashboard/balance', primary: 'Balance by Date', icon: AccountBalanceIcon, component: BalanceContainer },
  { to: '/dashboard/paymentshow/:id', primary: 'Balance by Date', component: PaymentShow },
  { to: '/dashboard/payment', primary: 'Payments', icon: ReceiptLongIcon, component: Payment },
  { to: '/dashboard/payment/create', primary: 'Payments', component: PaymentCreate },
  { to: '/dashboard/deposit', primary: 'Deposit', icon: RequestQuoteSharpIcon, component: Deposit },
  { to: '/dashboard/rider', primary: 'Riders', icon: DirectionsBikeIcon, component: Rider },
  { to: '/dashboard/rider/create', primary: 'Riders', component: CreateRider },
  { to: '/dashboard/rider/edit/:id', primary: 'Riders', component: EditRider },
  { to: '/dashboard/rider_dashboard', primary: 'Riders Book', icon: MenuBookOutlinedIcon, component: RiderDashboard },
  { to: '/dashboard/companies', primary: 'Company', icon: BusinessIcon, component: Company },
  { to: '/dashboard/companies/create', primary: 'Company', component: CreateCompany },
  { to: '/dashboard/companies/edit/:id', primary: 'Company', component: EditCompany },
  { to: '/dashboard/areas', primary: 'Area', icon: LocationOnIcon, component: Area },
  { to: '/dashboard/areas/create', primary: 'Area', component: CreateArea },
  { to: '/dashboard/areas/edit/:id', primary: 'Area', component: EditArea },
  { to: '/dashboard/change_password', primary: 'Change Password', icon: PasswordIcon, component: ChangePassword },
  { to: '/dashboard/delivery_charge', primary: 'Delivery Charge', icon: AttachMoneyIcon, component: DeliveryCharge },
];

export const sidebar = (
  <div>
    {routeList
      .filter((item) => item.icon)
      .map((item, index) => (
        <ListItemLink key={index} to={item.to} primary={item.primary} icon={item.icon} />
      ))}
  </div>
);

export const routeContainer = () => (
  <Switch>
    {routeList
      .filter((item) => item.component)
      .map((item, index) => (
        <Route key={index} exact path={item.to} component={item.component} />
      ))}
  </Switch>
);
